module.exports = __webpack_public_path__ + "img/shotzzy.815fe1d4.png";